export const FETCH_WAREHOUSESPLAN_INIT_ACTION = "FETCH_WAREHOUSESPLAN_INIT_ACTION";
export const FETCH_WAREHOUSESPLAN_SUCCESS_ACTION = FETCH_WAREHOUSESPLAN_INIT_ACTION + "_SUCCESS";
export const FETCH_WAREHOUSESPLAN_FAIL_ACTION = FETCH_WAREHOUSESPLAN_INIT_ACTION + "_ERROR";

export const FETCH_WAREHOUSESUBLIST_INIT_ACTION = "FETCH_WAREHOUSESUBLIST_INIT_ACTION";
export const FETCH_WAREHOUSESUBLIST_SUCCESS_ACTION = FETCH_WAREHOUSESUBLIST_INIT_ACTION + "_SUCCESS";
export const FETCH_WAREHOUSESUBLIST_FAIL_ACTION = FETCH_WAREHOUSESUBLIST_INIT_ACTION + "_ERROR";

export const FETCH_WAREHOUSEPAYMENTMODE_INIT_ACTION = "FETCH_WAREHOUSEPAYMENTMODE_INIT_ACTION";
export const FETCH_WAREHOUSEPAYMENTMODE_SUCCESS_ACTION = FETCH_WAREHOUSEPAYMENTMODE_INIT_ACTION + "_SUCCESS";
export const FETCH_WAREHOUSEPAYMENTMODE_FAIL_ACTION = FETCH_WAREHOUSEPAYMENTMODE_INIT_ACTION + "_ERROR";

export const FETCH_WAREHOUSESPROVIDER_INIT_ACTION = "FETCH_WAREHOUSESPROVIDER_INIT_ACTION";
export const FETCH_WAREHOUSESPROVIDER_SUCCESS_ACTION = FETCH_WAREHOUSESPROVIDER_INIT_ACTION + "_SUCCESS";
export const FETCH_WAREHOUSESPROVIDER_FAIL_ACTION = FETCH_WAREHOUSESPROVIDER_INIT_ACTION + "_ERROR";

export const WAREHOUSESUBSCRIBE_BANKPLAN_ACTION = "WAREHOUSESUBSCRIBE_BANKPLAN_ACTION";
export const WAREHOUSESUBSCRIBE_BANKPLAN_FAIL_ACTION = WAREHOUSESUBSCRIBE_BANKPLAN_ACTION + "_ERROR";
export const WAREHOUSESUBSCRIBE_BANKPLAN_SUCCESS_ACTION = WAREHOUSESUBSCRIBE_BANKPLAN_ACTION + "_SUCCESS";

export const WAREHOUSESUBSCRIBE_PLAN_ACTION = "WAREHOUSESUBSCRIBE_PLAN_ACTION";
export const WAREHOUSESUBSCRIBE_PLAN_FAIL_ACTION = WAREHOUSESUBSCRIBE_PLAN_ACTION + "_ERROR";
export const WAREHOUSESUBSCRIBE_PLAN_SUCCESS_ACTION = WAREHOUSESUBSCRIBE_PLAN_ACTION + "_SUCCESS";

export const CREATE_INVOICE_ACTION = "CREATE_INVOICE_ACTION";
export const CREATE_INVOICE_FAIL_ACTION = CREATE_INVOICE_ACTION + "_ERROR";
export const CREATE_INVOICE_SUCCESS_ACTION = CREATE_INVOICE_ACTION + "_SUCCESS";

export const CREATE_PAYMENT_ACTION = "CREATE_PAYMENT_ACTION";
export const CREATE_PAYMENT_FAIL_ACTION = CREATE_PAYMENT_ACTION + "_ERROR";
export const CREATE_PAYMENT_SUCCESS_ACTION = CREATE_PAYMENT_ACTION + "_SUCCESS";

export const FETCH_OTHERUSERS_INIT_ACTION = "FETCH_OTHERUSERS_INIT_ACTION";
export const FETCH_OTHERUSERS_SUCCESS_ACTION = FETCH_OTHERUSERS_INIT_ACTION + "_SUCCESS";
export const FETCH_OTHERUSERS_FAIL_ACTION = FETCH_OTHERUSERS_INIT_ACTION + "_ERROR";

export const CREATE_RAZORPAYORDER_ACTION = "CREATE_RAZORPAYORDER_ACTION";
export const CREATE_RAZORPAYORDER_FAIL_ACTION = CREATE_RAZORPAYORDER_ACTION + "_ERROR";
export const CREATE_RAZORPAYORDER_SUCCESS_ACTION = CREATE_RAZORPAYORDER_ACTION + "_SUCCESS";

export const FETCH_SIXMNTH_WAREHOUSESUB_INIT_ACTION = "FETCH_SIXMNTH_WAREHOUSESUB_INIT_ACTION";
export const FETCH_SIXMNTH_WAREHOUSESUB_SUCCESS_ACTION = FETCH_SIXMNTH_WAREHOUSESUB_INIT_ACTION + "_SUCCESS";
export const FETCH_SIXMNTH_WAREHOUSESUB_FAIL_ACTION = FETCH_SIXMNTH_WAREHOUSESUB_INIT_ACTION + "_ERROR";

export const FETCH_APPCONFIG_INIT = "FETCH_APPCONFIG_INIT";
export const FETCH_APPCONFIG_SUCCESS = FETCH_APPCONFIG_INIT+"_SUCCESS";
export const FETCH_APPCONFIG_FAIL = FETCH_APPCONFIG_INIT+"_FAIL";